import { hexToHslChannels, readableTextOn } from './utils';

export interface SalonTheme {
  primaryColor?: string | null;
  accentColor?: string | null;
  headingFont?: string | null;
  bodyFont?: string | null;
}

const BUILT_IN_FONTS = new Set(['Inter', 'Montserrat']);

function loadGoogleFont(family: string) {
  if (BUILT_IN_FONTS.has(family)) return;
  const id = `gf-${family.replace(/\s+/g, '-')}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}

/** Applies a salon's branding by overriding the CSS variables (light theme only). */
export function applySalonTheme(theme: SalonTheme | null | undefined, root: HTMLElement = document.documentElement) {
  if (!theme) return;
  if (theme.primaryColor) {
    const hsl = hexToHslChannels(theme.primaryColor);
    if (hsl) {
      root.style.setProperty('--primary', hsl);
      root.style.setProperty('--primary-foreground', readableTextOn(theme.primaryColor) === 'dark' ? '0 0% 12%' : '36 45% 96%');
    }
  }
  if (theme.accentColor) {
    const hsl = hexToHslChannels(theme.accentColor);
    if (hsl) {
      root.style.setProperty('--accent', hsl);
      root.style.setProperty('--ring', hsl);
    }
  }
  if (theme.headingFont) {
    loadGoogleFont(theme.headingFont);
    root.style.setProperty('--font-heading', `'${theme.headingFont}'`);
  }
  if (theme.bodyFont) {
    loadGoogleFont(theme.bodyFont);
    root.style.setProperty('--font-body', `'${theme.bodyFont}'`);
  }
}

export function clearSalonTheme(root: HTMLElement = document.documentElement) {
  ['--primary', '--primary-foreground', '--accent', '--ring', '--font-heading', '--font-body'].forEach((v) =>
    root.style.removeProperty(v),
  );
}
